var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-title text-center"},[_c('div',{staticClass:"my-5"},[_vm._v(" Page Not Found ")]),_c('div',[_vm._v(" Returning you to the dashboard in "+_vm._s(_vm.secondsLeft)+" seconds. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }